import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=180e62f2&scoped=true"
import script from "./ApplicationsTable.vue?vue&type=script&lang=js"
export * from "./ApplicationsTable.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsTable.vue?vue&type=style&index=0&id=180e62f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e62f2",
  null
  
)

export default component.exports